import type { ConvexReactClientOptions } from 'convex/react';

export function buildConvexClientOptions(env: {
  verbose: string | undefined;
  expectAuth?: boolean;
}): ConvexReactClientOptions {
  return {
    verbose: env.verbose === 'true',
    // Server-authenticated loads must send their token before snapshot
    // subscriptions. Public loads must remain free to query anonymously.
    expectAuth: env.expectAuth ?? false,
    // No "Reload site?" beforeunload dialog for in-flight mutations. Surfaces
    // like Work Chats fire constant background mutations (markRead debounce,
    // presence heartbeats), so the warning triggered on ~every reload; losing
    // one of those on unload is harmless, and real drafts are persisted
    // separately.
    unsavedChangesWarning: false,
    // The root layout passes a server-fetched token as `initialToken`. Once
    // the server confirms it, schedule a refresh from its expiry instead of
    // immediately fetching another token (the default), which cost a
    // /api/auth/convex/token round trip and a re-authentication (re-running
    // authenticated queries) on every cold load. The server still validates
    // the token; a rejected token falls back to a fresh fetch.
    initialAuthTokenReuse: true,
  };
}
